<template>
    <div class="fill-height of-y d-flex align-center mr-2" >
        <div class="ml-4 text-h5 font-weight-light">
            Classification
        </div>
        <div class="flex-grow-1">
            <slot></slot>
        </div>
        <v-expand-x-transition>
            <v-btn
                v-if="$store.state.ref.classification.tabIndex === 4"
                color="primary"
                small
                outlined
                class="mx-2"
                @click="$store.state.ref.classification.showCreate = true"
            >
                <v-icon left small>mdi-plus</v-icon>
                Manual time option
            </v-btn>
        </v-expand-x-transition>

        <div style="width: 300px">
            <v-text-field
                    placeholder="Search"
                    hide-details
                    class="pa-0 ma-0 mx-2"
                    color="primary"
                    prepend-inner-icon="mdi-magnify"
                    solo
                    dense
                    v-model="$store.state.ref.classification.filterStr"
            ></v-text-field>
        </div>
<!--        <v-btn-->
<!--                icon-->
<!--                color="primary"-->
<!--                class="mx-2"-->
<!--                small-->
<!--        >-->
<!--            <v-icon>mdi-microsoft-excel</v-icon>-->
<!--        </v-btn>-->
    </div>
</template>

<script>
export default {
    components: {

    },
    props: {
        shown: Boolean
    },
    data() {
        return {

        }
    },
    watch: {

    },
    methods: {

    },
    computed: {

    },
}
</script>

<style scoped>

</style>